import { render, staticRenderFns } from "./NatureOfLoss.vue?vue&type=template&id=6d1cf3c3&"
import script from "./NatureOfLoss.vue?vue&type=script&lang=js&"
export * from "./NatureOfLoss.vue?vue&type=script&lang=js&"
import style0 from "./NatureOfLoss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NatureOfLoss.vue"
export default component.exports